<template>
  <div style="position: absolute">
    <div
      :class="checkPage ? 'social--allPage' : 'social'"
      :style="checkPage ? '' : 'margin-bottom:12px;margin-left:10px;'"
    >
      <v-chip
        class="py-3 socialCover"
        small
        label
        style="border-radius: 23px 23px 23px 0px !important;background-color:#f5f5f575;z-index: 1;"
        :style="checkPage ? 'top:-25px;right:-25px;' : 'top:-30px;right:-50%'"
      >
        <template v-for="channel in channels">
          <div
            class="d-inline-block icon px-1"
            style="max-height: 20px;margin-right: 1px; border-radius: 2px 2px 2px 2px !important;"
            :key="channel.type + '_' + channel.icon"
            :style="{ 'background-color': channel.color }"
          >
            <i :class="`fab white--text ${channel.icon}`"></i>
          </div>
        </template>
      </v-chip>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    checkPage() {
      if (this.$route.name == 'allbots') {
        return true
      } else {
        return false
      }
    },
    channels() {
      let channels = [
        {
          type: 'facebook',
          icon: 'fab fa-facebook-square',
          color: '#3c5a99'
        },
        {
          type: 'line',
          icon: 'fab fa-line',
          color: '#06b901'
        },
        {
          type: 'instagram',
          icon: 'fab fa-instagram',
          color: '#d6249f'
        },
        {
          type: 'whatsapp',
          icon: 'fab fa-whatsapp',
          color: '#06b901'
        },
        {
          type: 'google',
          icon: 'fab fa-google',
          color: '#FFB306'
        }
      ]

      channels = channels.filter(el => {
        if (this.value.includes(el.type)) {
          return el
        } else {
          return (el.color = '#9e9e9e')
        }
      })
      return channels
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .social {
    margin-left: 30px !important;
  }
  .socialCover {
    max-width: 110px;
  }
  .icon {
    zoom: 0.8;
    max-height: 18px !important;
    margin: 0px 2px 0px 0px !important;
    padding: 2px 2px 2px 2px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/SocialBadge.vue